"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = postSubscribe;
async function postSubscribe(domain, email, userId) {
    const url = `https://pulse-email-api.ainewspulse.net/subscriptions/subscribe`;
    const requestBody = {
        app_domain: domain,
        email: email,
        user_id: userId,
    };
    try {
        // Perform the fetch request
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                data: data.detail,
                error: data.title,
                code: response.status,
            };
        }
        return { data, error: undefined, code: response.status };
    }
    catch (error) {
        return {
            data: null,
            error: error instanceof Error ? error.message : 'An unknown error occurred',
            code: undefined,
        };
    }
}
